import { useMemo } from 'react'
import { useCheckAuth } from '@/hooks'

// 判断权限的钩子
const useAuthComponent = (authCode) => {
  const { checkAuth } = useCheckAuth()
  const hasAuthorization = useMemo(() => {
    return checkAuth(authCode)
  }, [authCode, checkAuth])

  return hasAuthorization
}

export default useAuthComponent
